var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6903 0.985352H16.3419C20.2337 0.985352 23.9662 2.53138 26.7181 5.28333C29.4701 8.03529 31.0161 11.7677 31.0161 15.6596V16.3121C31.0161 20.2039 29.4701 23.9364 26.7181 26.6883C23.9662 29.4403 20.2337 30.9863 16.3419 30.9863H15.6903C11.7985 30.9863 8.06605 29.4403 5.3141 26.6883C2.56214 23.9364 1.01611 20.2039 1.01611 16.3121V15.6596C1.01611 11.7677 2.56214 8.03529 5.3141 5.28333C8.06605 2.53138 11.7985 0.985352 15.6903 0.985352Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3137 17.7278L21.2634 22.6775L22.6776 21.2633L17.7279 16.3136L22.6777 11.3638L21.2635 9.94956L16.3137 14.8993L11.3639 9.94956L9.94971 11.3638L14.8995 16.3136L9.94979 21.2633L11.364 22.6775L16.3137 17.7278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/closeCircle.55ebd615356caa45900dbfb2ec069178.svg";
export { ForwardRef as ReactComponent };